import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchPatientsElasticQueryVariables = Types.Exact<{
  patient: Types.SearchPatientInput;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type SearchPatientsElasticQuery = { readonly __typename?: 'Query', readonly searchPatients?: ReadonlyArray<{ readonly __typename?: 'Patient', readonly uuid: string, readonly person: { readonly __typename?: 'Person', readonly dob: string, readonly gender: Types.Gender, readonly nationalIdNumber?: string | null, readonly name: { readonly __typename?: 'Name', readonly firstname?: string | null, readonly middlename?: string | null, readonly lastname?: string | null }, readonly contactPoints: ReadonlyArray<{ readonly __typename?: 'ContactPoint', readonly system: Types.ContactPointSystem, readonly value: string } | null> }, readonly insurance?: { readonly __typename?: 'Insurance', readonly insuranceDetails?: unknown | null } | null, readonly registrationPayment: { readonly __typename?: 'RegistrationPaymentOverview', readonly status: Types.PaymentStatus } } | null> | null };


export const SearchPatientsElasticDocument = gql`
    query SearchPatientsElastic($patient: SearchPatientInput!, $offset: Int, $limit: Int) {
  searchPatients(
    patient: $patient
    offset: $offset
    limit: $limit
    useElastic: true
  ) {
    uuid
    person {
      dob
      gender
      nationalIdNumber
      name {
        firstname
        middlename
        lastname
      }
      contactPoints {
        system
        value
      }
    }
    insurance {
      insuranceDetails
    }
    registrationPayment {
      status
    }
  }
}
    `;

/**
 * __useSearchPatientsElasticQuery__
 *
 * To run a query within a React component, call `useSearchPatientsElasticQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPatientsElasticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPatientsElasticQuery({
 *   variables: {
 *      patient: // value for 'patient'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchPatientsElasticQuery(baseOptions: Apollo.QueryHookOptions<SearchPatientsElasticQuery, SearchPatientsElasticQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPatientsElasticQuery, SearchPatientsElasticQueryVariables>(SearchPatientsElasticDocument, options);
      }
export function useSearchPatientsElasticLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPatientsElasticQuery, SearchPatientsElasticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPatientsElasticQuery, SearchPatientsElasticQueryVariables>(SearchPatientsElasticDocument, options);
        }
export type SearchPatientsElasticQueryHookResult = ReturnType<typeof useSearchPatientsElasticQuery>;
export type SearchPatientsElasticLazyQueryHookResult = ReturnType<typeof useSearchPatientsElasticLazyQuery>;
export type SearchPatientsElasticQueryResult = Apollo.QueryResult<SearchPatientsElasticQuery, SearchPatientsElasticQueryVariables>;